import { render } from "./categories.vue?vue&type=template&id=7bccb6bc&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"

import "./categories.vue?vue&type=style&index=0&id=7bccb6bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bccb6bc"]])

export default __exports__